export default __webpack_public_path__ + "static/bump-c999cf2be168b647970e69e307c5b75e.png";